// 公告栏循环滚动脚本
(function() {
  'use strict';

  function initAnnouncementScroll() {
    const containers = document.querySelectorAll('.announcement-bar__scroll-container');
    
    containers.forEach(container => {
      const track = container.querySelector('.announcement-bar__scroll-track');
      const existingItems = track.querySelectorAll('.announcement-bar__scroll-item');
      
      if (!track || !existingItems.length) return;
      
      // 使用第一个项目作为模板
      const templateItem = existingItems[0];
      
      // 计算需要的项目数量
      const itemsCount = Math.ceil(window.innerWidth / 200) + 3;
      
      // 如果当前项目数量不够，添加更多
      if (existingItems.length < itemsCount) {
        for (let i = existingItems.length; i < itemsCount; i++) {
          const clonedItem = templateItem.cloneNode(true);
          track.appendChild(clonedItem);
        }
      }
      
      // 计算滚动速度 - 基于文字长度（更慢的速度）
      const textLength = templateItem.textContent.length;
      const baseSpeed = Math.max(70, Math.min(130, textLength * 2)); // 70-130秒之间
      track.style.animationDuration = `${baseSpeed}s`;
      
      // 确保动画立即开始
      track.style.animationPlayState = 'running';
      
      // 监听窗口大小改变
      const handleResize = () => {
        const newItemsCount = Math.ceil(window.innerWidth / 200) + 3;
        const currentItems = track.querySelectorAll('.announcement-bar__scroll-item');
        
        if (currentItems.length < newItemsCount) {
          // 需要添加更多项目
          for (let i = currentItems.length; i < newItemsCount; i++) {
            const clonedItem = templateItem.cloneNode(true);
            track.appendChild(clonedItem);
          }
        } else if (currentItems.length > newItemsCount + 5) {
          // 如果项目太多，移除一些（保留一些余量）
          for (let i = currentItems.length - 1; i >= newItemsCount; i--) {
            currentItems[i].remove();
          }
        }
      };
      
      window.addEventListener('resize', handleResize);
    });
  }

  // 当DOM加载完成时初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementScroll);
  } else {
    initAnnouncementScroll();
  }

  // Shopify主题编辑器支持
  document.addEventListener('shopify:section:load', initAnnouncementScroll);
  document.addEventListener('shopify:section:reorder', initAnnouncementScroll);
})();
